import { ReactNode } from 'react'

import styled, { css } from 'styled-components'

import VStack from '../Flex/VStack'
import { T } from '../Text/Text'

type Props = {
  isOrdered?: boolean
  title?: string
  children: ReactNode
}

const listStyles = css<{ $isOrdered: boolean }>`
  list-style-type: ${({ $isOrdered }) => ($isOrdered ? 'decimal' : 'disc')};
  padding-left: 20px;
  margin: 4px 0;

  & > li {
    margin-bottom: 4px;

    &::marker {
      font-family: ${({ theme }) => theme.fontFamily};
      font-size: 0.9em;
    }
  }
`

const StyledList = styled.ul<{ $isOrdered: boolean }>`
  ${listStyles}
`

const List = ({ isOrdered = false, title, children }: Props) => {
  return (
    <VStack align="stretch">
      {title && <T.Body className="font-semibold">{title}</T.Body>}
      <StyledList as={isOrdered ? 'ol' : 'ul'} $isOrdered={isOrdered}>
        {children}
      </StyledList>
    </VStack>
  )
}

const Item = ({ children }: { children: ReactNode }) => {
  return <li>{typeof children === 'string' ? <T.Body>{children}</T.Body> : children}</li>
}

List.Item = Item

export default List
